import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=56c79bc9&scoped=true"
import script from "./UserGroupForm.vue?vue&type=script&lang=js"
export * from "./UserGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c79bc9",
  null
  
)

export default component.exports